const categories = [
    "Business",
    "Entertainment",
    "India",
    "Politics",
    "LifeStyle",
    "ScienceAndTechnology",
    "Sports",
    "World"
];

export default categories;